(function () {
  if (customElements.get("m-preorder-countdown")) return;

  // "2026-10-31" -> lokale Mitternacht (nicht UTC), damit der Countdown zum Datum auf der Seite passt
  const parseDay = (str) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str || "");
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  };
  const pad = (n) => String(n).padStart(2, "0");

  class MPreorderCountdown extends HTMLElement {
    connectedCallback() {
      this.target = parseDay(this.dataset.target);
      if (!this.target) return;
      this.start = parseDay(this.dataset.start);
      this.cells = {
        d: this.querySelector("[data-cd-d]"),
        h: this.querySelector("[data-cd-h]"),
        m: this.querySelector("[data-cd-m]"),
        s: this.querySelector("[data-cd-s]"),
      };
      this.bar = this.querySelector("[data-cd-bar]");
      this.reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this._tick();
      this.timer = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    _set(key, val) {
      const el = this.cells[key];
      if (!el || el.textContent === val) return;
      el.textContent = val;
      if (this.reduce) return;
      el.classList.remove("is-tick");
      void el.offsetWidth;
      el.classList.add("is-tick");
    }

    _tick() {
      const now = new Date();
      const diff = this.target - now;
      if (diff <= 0) {
        clearInterval(this.timer);
        const cd = this.querySelector("[data-cd]");
        const done = this.querySelector("[data-cd-done]");
        if (cd) cd.hidden = true;
        if (done) done.hidden = false;
        if (this.bar) this.bar.style.width = "100%";
        return;
      }
      const sec = Math.floor(diff / 1000);
      this._set("d", String(Math.floor(sec / 86400)));
      this._set("h", pad(Math.floor((sec % 86400) / 3600)));
      this._set("m", pad(Math.floor((sec % 3600) / 60)));
      this._set("s", pad(sec % 60));

      if (this.bar && this.start && this.target > this.start) {
        const p = Math.min(1, Math.max(0.04, (now - this.start) / (this.target - this.start)));
        this.bar.style.width = (p * 100).toFixed(1) + "%";
      } else if (this.bar) {
        this.bar.parentElement.hidden = true;
      }
    }
  }

  customElements.define("m-preorder-countdown", MPreorderCountdown);

  // Kompatibilitätstabelle: Serien-Filter und Suche. Ohne JS ist alles sichtbar.
  class MModelList extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll("[data-group]"));
      this.chips = Array.from(this.querySelectorAll("[data-chip]"));
      this.search = this.querySelector("[data-search]");
      this.empty = this.querySelector("[data-empty]");
      this.series = "";

      this.chips.forEach((c) => c.addEventListener("click", () => {
        this.series = c.dataset.chip;
        this.chips.forEach((x) => x.classList.toggle("is-on", x === c));
        this._render();
      }));
      if (this.search) this.search.addEventListener("input", () => this._render());
    }

    _render() {
      const terms = (this.search ? this.search.value : "").trim().toLowerCase().split(/\s+/).filter(Boolean);
      let total = 0;
      this.groups.forEach((g) => {
        const inSeries = !this.series || g.dataset.group === this.series;
        let n = 0;
        g.querySelectorAll("[data-row]").forEach((r) => {
          const hit = inSeries && terms.every((t) => r.dataset.q.includes(t));
          r.hidden = !hit;
          if (hit) n++;
        });
        g.hidden = n === 0;
        total += n;
      });
      if (this.empty) this.empty.hidden = total > 0;
    }
  }

  if (!customElements.get("m-model-list")) customElements.define("m-model-list", MModelList);
})();
